/**
 * ISO anlarını inceleyenin dilinde ve ÇALIŞANIN etkin diliminde çizer.
 *
 * Dilim inceleyenin tarayıcısından gelseydi aynı damga iki yöneticiye iki farklı
 * saat gösterirdi, üstelik sunucunun onu bağladığı gün hiç değişmezdi
 * (SEM-6938). Onaylanan şey bir duvar saatidir; iki onaycı aynı saati görmeli.
 */
export function formatTimeInstant(locale: string, timeZone: string, iso: string): string {
  const value = new Date(iso);
  if (Number.isNaN(value.getTime())) return iso;
  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone,
    }).format(value);
  } catch {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone: "UTC",
    }).format(value);
  }
}
